import React, { Component } from "react";
import { Line, Circle } from "rc-progress";

import Api from "../../lib/componentApi";
import Loading from "../Common/Loading";
import moment from "moment";

export default class Reviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      reviews: "",
      list: [],
      limit: 15,
      index: 0,
      hasMore: true
    };
    window.onscroll = () => {
      const {
        getReviews,
        state: { loading, hasMore, index }
      } = this;
      if (loading || !hasMore) return;
      if (
        document &&
        document.documentElement &&
        document.documentElement.offsetHeight
      ) {
        if (
          window.innerHeight + document.documentElement.scrollTop ===
          document.documentElement.offsetHeight
        ) {
          this.setState({ index: index + 15 }, () => {
            getReviews();
          });
        }
      }
    };
  }
  getReviews = () => {
    const { restaurantUid } = this.props;
    const { limit, index } = this.state;
    Api.post(
      "/api/restaurant/reviews",
      { restaurantUid, limit, index },
      (response, errors) => {
        this.setState({ loading: true });
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "reviews-code");
        } else {
          console.log(response);
          const { list } = this.state;
          if (response.totalCount > list.length) {
            this.setState({
              reviews: response,
              list: [...list, ...response.list],
              hasMore: true
            });
          } else {
            this.setState({
              hasMore: false,
              reviews: response,
              list: [...list]
            });
          }
        }
        this.setState({ loading: false });
      }
    );
  };
  componentDidMount() {
    this.getReviews();
  }
  render() {
    const { reviews, loading, list } = this.state;
    const { handleCloseReviews, restaurantName } = this.props;
    return (
      <div>
        {/* Header */}
        <div className="head-general with-back visible-xs">
          <a
            href="javascript: void(0)"
            onClick={handleCloseReviews}
            className="back"
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Reviews</h4>
          <a href="javascript: void(0)" className="close">
            {(reviews && reviews.totalCount) || (
              <i className="icon icon-close" onClick={handleCloseReviews} />
            )}
          </a>
        </div>
        {/* Header */}
        {(loading && <Loading />) ||
          (reviews && (
            <div className="reviews-page">
              <div className="white-bg mt-10px section1 d-flex justify-content-between">
                <div className="big-circle">
                  <Circle
                    percent={
                      (reviews.avgScore && parseFloat(reviews.avgScore) * 10) ||
                      0
                    }
                    strokeWidth="5"
                    className={`sC${parseInt(reviews.avgScore)}`}
                  />
                  <p>{parseFloat(reviews.avgScore).toFixed(1)}</p>
                  <label className="small-label">
                    {reviews.totalCount} Reviews
                  </label>
                </div>
                <div className="lines">
                  <div>
                    <h5>Food Quality</h5>
                    <Line
                      percent={
                        (reviews.foodQualityScore &&
                          parseInt(reviews.foodQualityScore)) ||
                        0
                      }
                      strokeWidth="5"
                      className={`sC${Math.floor(
                        parseInt(reviews.foodQualityScore) / 10
                      )}`}
                    />
                  </div>
                  <div>
                    <h5>Delivery Time</h5>
                    <Line
                      percent={
                        (reviews.deliveryTimeScore &&
                          parseInt(reviews.deliveryTimeScore)) ||
                        0
                      }
                      strokeWidth="5"
                      className={`sC${Math.floor(
                        parseInt(reviews.deliveryTimeScore) / 10
                      )}`}
                    />
                  </div>
                  <div>
                    <h5>Restaurant Service</h5>
                    <Line
                      percent={
                        (reviews.restaurantServiceScore &&
                          parseInt(reviews.restaurantServiceScore)) ||
                        0
                      }
                      strokeWidth="5"
                      className={`sC${Math.floor(
                        parseInt(reviews.restaurantServiceScore) / 10
                      )}`}
                    />
                  </div>
                </div>
              </div>
              <div className="reviews-list">
                {(list && list.length && (
                  <ul>
                    {list.map(listItem => (
                      <li
                        className="d-flex justify-content-between white-bg"
                        key={listItem.id}
                      >
                        <div className="desc">
                          <h5>{listItem.userName}</h5>
                          <p>{listItem.content}</p>
                          <label className="small-label">
                            {moment
                              .utc(listItem.date)
                              .local()
                              .format("DD-MM-YYYY")}
                          </label>
                          {(listItem.reply && listItem.reply.length && (
                            <div className="reply">
                              <ul>
                                {listItem.reply.map(replyItem => (
                                  <li key={replyItem.id} className="d-flex">
                                    <div>
                                      <icon className="icon icon-corner-down right" />
                                    </div>
                                    <div>
                                      <h5>{restaurantName}</h5>
                                      <p>{replyItem.content}</p>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )) || <noscript />}
                        </div>
                        <div className="score">
                          <label
                            className={`avg-score s${parseInt(listItem.score)}`}
                          >
                            {listItem.score}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                )) || (
                  <p className="empty-body white-bg mt-10px">
                    Comment not found.
                  </p>
                )}
              </div>
            </div>
          )) || (
            <div className="empty-body white-bg mt-10px">Review not found.</div>
          )}
      </div>
    );
  }
}
